(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athlete-carousel"] && !Shopify.designMode) return;
  try {
    
  class AthleteCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-carousel-track]');
      this.viewport = this.querySelector('.athlete-carousel__viewport');
      this.prevBtn = this.querySelector('[data-carousel-prev]');
      this.nextBtn = this.querySelector('[data-carousel-next]');
      this.dotsWrap = this.querySelector('[data-carousel-dots]');
      this.cards = Array.from(this.querySelectorAll('[data-carousel-card]'));

      this.style.setProperty('--ac-per-view-desktop', this.dataset.perViewDesktop);
      this.style.setProperty('--ac-per-view-tablet', this.dataset.perViewTablet);
      this.style.setProperty('--ac-per-view-mobile', this.dataset.perViewMobile);

      if (!this.track || this.cards.length === 0) return;

      this.buildDots();
      this.bindArrows();
      this.bindScroll();
      this.updateState();
    }

    buildDots() {
      if (!this.dotsWrap) return;
      this.cards.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'athlete-carousel__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => this.scrollToCard(index));
        this.dotsWrap.appendChild(dot);
      });
      this.dots = Array.from(this.dotsWrap.children);
    }

    bindArrows() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
      }
    }

    bindScroll() {
      let ticking = false;
      this.viewport.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            this.updateState();
            ticking = false;
          });
          ticking = true;
        }
      });
    }

    getCardStep() {
      const card = this.cards[0];
      const style = window.getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap || style.gap || 0);
      return card.getBoundingClientRect().width + gap;
    }

    scrollByCard(direction) {
      this.viewport.scrollBy({ left: direction * this.getCardStep(), behavior: 'smooth' });
    }

    scrollToCard(index) {
      const step = this.getCardStep();
      this.viewport.scrollTo({ left: index * step, behavior: 'smooth' });
    }

    updateState() {
      const step = this.getCardStep();
      const activeIndex = Math.round(this.viewport.scrollLeft / step);

      if (this.dots) {
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
      }

      if (this.prevBtn) this.prevBtn.disabled = this.viewport.scrollLeft <= 4;
      if (this.nextBtn) {
        const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
        this.nextBtn.disabled = this.viewport.scrollLeft >= maxScroll - 4;
      }
    }
  }

  customElements.define('athlete-carousel', AthleteCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
